<template>
  <b-modal
    ref="modal"
    title="Retorno de vasilhames"
    centered
    no-close-on-backdrop
    @hidden="aoFechar"
  >
    <p class="mb-3">
      Informe quantos cascos foram devolvidos para
      <strong>
        {{ produto.descricao }}
      </strong>
      .
    </p>

    <b-form-group label="Quantidade vendida">
      <b-form-input :value="quantidade" disabled />
    </b-form-group>

    <b-form-group label="Cascos devolvidos" label-for="quantidade-retornada">
      <b-form-input
        id="quantidade-retornada"
        ref="quantidadeRetornada"
        v-model.number="quantidadeRetornada"
        type="number"
        min="0"
        :max="quantidade"
        step="1"
        @keyup.enter="confirmar"
      />
      <small class="text-muted">
        Informe um número inteiro entre 0 e {{ quantidade }}.
      </small>
    </b-form-group>

    <b-alert show variant="light" class="mb-0">
      <div class="d-flex justify-content-between">
        <span>Com retorno ({{ quantidadeComRetorno }})</span>
        <strong>{{ formatarMoeda(precoComRetorno) }} cada</strong>
      </div>
      <div class="d-flex justify-content-between mt-2">
        <span>Sem retorno ({{ quantidadeSemRetorno }})</span>
        <strong>{{ formatarMoeda(precoSemRetorno) }} cada</strong>
      </div>
    </b-alert>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
      <b-button variant="primary" @click="confirmar">Confirmar</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "RetornavelProdutoModal",
  data() {
    return {
      produto: {},
      quantidade: 0,
      quantidadeRetornada: 0,
      precoComRetorno: 0,
      resolver: null,
    };
  },
  computed: {
    precoSemRetorno() {
      return Number(this.produto.preco_sem_retorno) || 0;
    },
    quantidadeComRetorno() {
      const quantidade = Number(this.quantidadeRetornada);
      return Number.isInteger(quantidade) && quantidade >= 0
        ? Math.min(quantidade, this.quantidade)
        : 0;
    },
    quantidadeSemRetorno() {
      return this.quantidade - this.quantidadeComRetorno;
    },
  },
  methods: {
    abrir({ produto, quantidade, preco }) {
      if (this.resolver) {
        this.resolver(null);
      }

      this.produto = produto || {};
      this.quantidade = Number(quantidade) || 0;
      this.quantidadeRetornada = this.quantidade;
      this.precoComRetorno = Number(preco) || 0;

      this.$refs.modal.show();
      this.$nextTick(() => {
        const input = this.$refs.quantidadeRetornada;
        if (input?.$el) input.$el.focus();
      });

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    confirmar() {
      const quantidade = Number(this.quantidadeRetornada);

      if (
        !Number.isInteger(quantidade) ||
        quantidade < 0 ||
        quantidade > this.quantidade
      ) {
        this.$toast.warning(
          `Informe uma quantidade inteira entre 0 e ${this.quantidade}.`
        );
        return;
      }

      this.finalizar(quantidade);
    },
    cancelar() {
      this.finalizar(null);
    },
    finalizar(resultado) {
      const resolver = this.resolver;
      this.resolver = null;
      if (resolver) resolver(resultado);
      this.$refs.modal.hide();
    },
    aoFechar() {
      if (this.resolver) {
        this.resolver(null);
        this.resolver = null;
      }
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor) || 0);
    },
  },
};
</script>
